import { render, staticRenderFns } from "./smhManage.vue?vue&type=template&id=13c137f0&scoped=true&"
import script from "./smhManage.vue?vue&type=script&lang=js&"
export * from "./smhManage.vue?vue&type=script&lang=js&"
import style0 from "./smhManage.vue?vue&type=style&index=0&id=13c137f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c137f0",
  null
  
)

export default component.exports